// sagas.js
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from "../actions/employeeTypes.js";
import * as actions from "../actions/employeeActions.js";
import axiosInstance from '../../interceptor/interceptor.js';  


// Worker Saga: Will fetch employee types from API
function* fetchEmployeeTypesSaga() {
    try {
        const response = yield call(axiosInstance.get, '/auth/roles');
        ////console.log(response.data);
        yield put(actions.fetchEmployeeTypesSuccess(response.data.employeeTypes));
    } catch (error) {
        yield put(actions.fetchEmployeeTypesFailure(error.message));
    }
}




// Watch for the FETCH_EMPLOYEE_TYPES_REQUEST action and trigger the fetchEmployeeTypesSaga
export default function* watchFetchData() {
    yield takeLatest(types.FETCH_EMPLOYEE_TYPES_REQUEST,fetchEmployeeTypesSaga);
}

